var _class, _descriptor, _descriptor2, _descriptor3, _BaseMedicalHistoryFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, set } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import ComorbiditiesAndAllergiesChangedJournalEvent from "comorbidity/models/comorbidities-and-allergies-changed-journal-event";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import JournalEventBasedComponent, { ForcModelPojo } from "core/components/forc/abstract/journal-event-based-component";
import JournalEventModel from "core/models/journal-event";
import ParogMedicalHistoryChangedJournalEvent from "core/models/medical-history-changed-journal-event";
import Patient from "core/models/patient";
import TreatmentPrescriptionChangedJournalEvent from "core/models/treatment-prescription-changed-journal-event";
import Vaccine from "core/models/vaccine";
import ConfigurationService from "core/services/configuration";
import FetcherService from "core/services/fetcher";
import { Changeset, EmberChangeset } from "ember-changeset";
/**
 * This component contains the shared logic about the medical history.
 * So that when defining the edition form for a parog, we just need to setup
 * the `journalEventProperties` array, containing the `sharedProperties` and
 * the parog specfifc ones.
 */
let BaseMedicalHistoryFormComponent = (_class = (_BaseMedicalHistoryFormComponent = class BaseMedicalHistoryFormComponent extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "configuration", _descriptor, this);
    _initializerDefineProperty(this, "fetcher", _descriptor2, this);
    _initializerDefineProperty(this, "vaccinesAreDirty", _descriptor3, this);
    _defineProperty(this, "sharedProperties", ["occurredAt", "vaccines", "comments"]);
    _defineProperty(this, "retrieveJournalEvent", () => this.args.patient.medicalHistoryChangedJournalEvent);
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.occurredAt = new Date();
    }
    if (!model.vaccines) {
      model.vaccines = [new Vaccine("pneumococcus"), new Vaccine("dtPolio"), new Vaccine("yellowFever"), new Vaccine("seasonalFlu"), new Vaccine("sarsCov2")];
    }
    return model;
  }
  get comorbiditiesModel() {
    const lastComorbiditiesJe = this.patient.comorbiditiesAndAllergiesChangedJournalEvent;
    if (!lastComorbiditiesJe) {
      return this.store.createRecord("comorbidities-and-allergies-changed-journal-event", {
        occurredAt: new Date()
      });
    }
    return lastComorbiditiesJe;
  }
  get treatmentsModel() {
    const lastTreatmentPrescriptionChangedJournalEvent = this.patient.lastTreatmentPrescriptionChangedJournalEvent;
    if (!lastTreatmentPrescriptionChangedJournalEvent) {
      return this.store.createRecord("treatment-prescription-changed-journal-event", {
        occurredAt: new Date(),
        ignoredAtcCodes: [],
        atc: []
      });
    }
    return lastTreatmentPrescriptionChangedJournalEvent;
  }
  get comorbiditiesChangeset() {
    const comorbiditiesChangeset = Changeset(this.comorbiditiesModel);
    Object.defineProperty(this, "comorbiditiesChangeset", {
      value: comorbiditiesChangeset,
      writable: false
    });
    return this.comorbiditiesChangeset;
  }
  get treatmentsChangeset() {
    const treatmentsChangeset = Changeset(this.treatmentsModel);
    Object.defineProperty(this, "treatmentsChangeset", {
      value: treatmentsChangeset,
      writable: false
    });
    return this.treatmentsChangeset;
  }
  get isDirty() {
    if (this.patient.medicalHistoryChangedJournalEvent) {
      return this.vaccinesAreDirty || this.comorbiditiesChangeset.isDirty || this.treatmentsChangeset.isDirty || super.isDirty;
    }
    return true;
  }
  setDoneProperty(targetVaccine, value) {
    this.setVaccinePropertyInChangeset(targetVaccine, "done", value);
  }
  setVaccinationDateProperty(targetVaccine, value) {
    this.setVaccinePropertyInChangeset(targetVaccine, "vaccinationDate", value);
  }
  setVaccinePropertyInChangeset(targetVaccine, key, value) {
    const vaccines = this.changeset.get("vaccines");
    const vaccine = vaccines.find(vaccine => vaccine.name == targetVaccine.name);
    set(vaccine, key, value);
    this.vaccinesAreDirty = true;
    this.changeset.set("vaccines", vaccines);
  }
  get shouldShowDateLabel() {
    const vaccines = this.changeset.get("vaccines");
    return vaccines?.some(vaccine => vaccine.done);
  }
  async saveModel() {
    if (this.comorbiditiesChangeset.isDirty) {
      if (this.comorbiditiesModel.get("isNew")) {
        this.comorbiditiesChangeset.set("patient", this.patient);
      }
      await this.comorbiditiesChangeset.save();
    }
    if (this.treatmentsChangeset.isDirty) {
      if (!this.treatmentsChangeset.get("prescriptions")) {
        this.treatmentsChangeset.set("prescriptions", []);
      }
      this.treatmentsChangeset.set("patient", this.patient);
      await this.treatmentsChangeset.save();
    }
    const model = await super.saveModel();
    await this.configuration.fetchConfigurationsForPatient(this.patient);
    const bioExamFqcyJes = await this.fetcher.loadRecords("bio-exam-frequency-changed-journal-event", {
      filter: {
        patient_id: this.patient.id
      }
    });
    await this.fetcher.loadRecords("medical-act-frequency-changed-journal-event", {
      filter: {
        patient_id: this.patient.id
      }
    });
    await Promise.all(bioExamFqcyJes.map(je => {
      return this.fetcher.loadRecords("loinc", {
        filter: {
          loinc: je.loincs
        },
        include: "bio-exam-order"
      });
    }));
    return model;
  }
}, _defineProperty(_BaseMedicalHistoryFormComponent, "fullComponentId", "medical-history/edition-form"), _defineProperty(_BaseMedicalHistoryFormComponent, "forcDisplayName", "Synthèse médicale"), _defineProperty(_BaseMedicalHistoryFormComponent, "journalEventClass", ParogMedicalHistoryChangedJournalEvent), _BaseMedicalHistoryFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "configuration", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fetcher", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "vaccinesAreDirty", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setDoneProperty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDoneProperty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setVaccinationDateProperty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setVaccinationDateProperty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setVaccinePropertyInChangeset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setVaccinePropertyInChangeset"), _class.prototype), _class);
export { BaseMedicalHistoryFormComponent as default };